module.exports = __webpack_public_path__ + "media/gundula6.482d9b46.mp3";